module.exports = __webpack_public_path__ + "img/8cd98cb.jpg";